import { AnyAction } from '@reduxjs/toolkit';
import {
  IDetailsOrderData,
  IDetailsQuotationData,
  OrderProductsSteps,
  OrderTabsEnum,
  ShippingType,
} from 'types/Order.types';
import {
  COMPANY_CHANGED,
  RESET_ORDER,
  SET_ACTIVE_TAB,
  SET_COMPANY_ID,
  SET_PRODUCT_ID,
  SET_ORDER_PRODUCTS_STEP,
  SET_DETAILS_ORDER_DATA,
  SET_DETAILS_QUOTATION_DATA,
} from 'store/constants';

export interface IOrderReducerState {
  activeTab: OrderTabsEnum;
  companyId: string;
  productId: string;
  orderProductsStep: OrderProductsSteps;
  detailsOrderData: IDetailsOrderData;
  detailsQuotationData: IDetailsQuotationData;
}

export const INIT_DETAILS_ORDER_DATA: IDetailsOrderData = {
  shipping_type: ShippingType.DEFAULT,
  order_reference: '',
  requested_delivery_date: '',
  shipping_address_code: null,
  shipping_address_data: null,
  is_pickup: false,
  validDetails: false,
};

const INIT_DETAILS_QUOTATION_DATA: IDetailsQuotationData = {
  first_name: '',
  last_name: '',
  title: '',
  email: '',
  phone: '',
  country: '',
  zip_code: '',
  house_number: '',
  city: '',
  street: '',
  company_name: '',
  vat_number: '',
  reference: '',
  days_valid: '',
  hasAlternativeShippingAddress: false,
  alt_country: '',
  alt_zip_code: '',
  alt_house_number: '',
  alt_city: '',
  alt_street: '',
  validDetails: false,
};

const INIT_STATE: IOrderReducerState = {
  activeTab: OrderTabsEnum.Company,
  companyId: '',
  productId: '',
  orderProductsStep: OrderProductsSteps.Selection,
  detailsOrderData: INIT_DETAILS_ORDER_DATA,
  detailsQuotationData: INIT_DETAILS_QUOTATION_DATA,
};

const orderReducer = (state = INIT_STATE, action: AnyAction) => {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };
    case COMPANY_CHANGED:
      return {
        ...INIT_STATE,
      };
    case RESET_ORDER:
      return {
        ...state,
        activeTab: OrderTabsEnum.Company,
        companyId: '',
        productId: '',
        orderProductsStep: OrderProductsSteps.Selection,
        detailsOrderData: INIT_DETAILS_ORDER_DATA,
        detailsQuotationData: INIT_DETAILS_QUOTATION_DATA,
      };
    case SET_COMPANY_ID:
      return { ...state, companyId: action.payload };
    case SET_PRODUCT_ID:
      return { ...state, productId: action.payload };
    case SET_ORDER_PRODUCTS_STEP:
      return { ...state, orderProductsStep: action.payload };
    case SET_DETAILS_ORDER_DATA:
      return { ...state, detailsOrderData: action.payload };
    case SET_DETAILS_QUOTATION_DATA:
      return { ...state, detailsQuotationData: action.payload };
    default:
      return state;
  }
};

export default orderReducer;
